export default __webpack_public_path__ + "static/media/website-06 1.b5730f19.png";